const tabsProducts = () => {
  $(document).on(
    'click',
    '[id*=tabs-products-] .tabs-products__tab-list li',
    (event) => {
      const $this = $(event.currentTarget);
      const currentSelectedSelector = $this.data('tab-button');
      const parentList = $this.closest('.tabs-products__tab-list ul');

      const parentSection = $this.closest('[id*=tabs-products-]');

      parentList.find('li').removeClass('active');
      $this.addClass('active');

      parentSection
        .find('[id*=mr-custom-product-slider-]')
        .removeClass('active');
      $(`#${currentSelectedSelector}`).addClass('active');

      // console.log($this.closest('.is-open'));
      if (
        $this.closest('.is-open').length <= 0 ||
        $this.closest('.pill').length > 0
      ) {
        $(window).trigger('custom-trigger-section-slider-event');
      }
    },
  );
};

export default tabsProducts;
